
import { defineComponent } from 'vue';
import PSPDFKitContainer from '@/components/PSPDFKitContainer.vue';

export default defineComponent({
  props: ['blobUrl'],
  components: { PSPDFKitContainer },
  setup() {
    function handleLoaded(instance) {
      console.log('PSPDFKit has loaded: ', instance);
      // do something
    }
    return {
      handleLoaded,
    };
  },
});
